export class CancelData {
    contract_id: number;
    reason_id: number;
    canceled_at: string;
    odometer: number;
    attachment? : any;
    email? : any;

    constructor(cancelData: CancelData) {
        this.contract_id = cancelData.contract_id;
        this.reason_id = cancelData.reason_id;
        this.canceled_at = cancelData.canceled_at;
        this.odometer = cancelData.odometer;
        this.attachment = cancelData.attachment;
        this.email = cancelData.email;
    }
}

export interface CancelQuote {
    retail_cost: number,
    net_cost: number,
    non_ref_fee: number,
    non_ref_commission: number,
    cancellation_fee: number,
    refund_from_admin: number,
    refund_from_seller: number,
    cancellation_refund_amount: number,
    factors: {
        term: number,
        mileage: number,
        cancel: number
    },
    products: any[],
}

export class CancelRequestData {
    reason_id: number;
    canceled_at: string;
    description: string;
    cancellation_mileage: number;
    is_active: number;
    payment_method_id?: number;
    email: string
    attachment? : any;

    constructor(cancelData: CancelRequestData) {
        this.reason_id = cancelData.reason_id;
        this.canceled_at = cancelData.canceled_at;
        this.description = cancelData.description;
        this.cancellation_mileage = cancelData.cancellation_mileage;
        this.is_active = cancelData.is_active;
        this.payment_method_id = cancelData?.payment_method_id;
        this.email = cancelData.email;
        this.attachment = cancelData.attachment;
    }
  }
